'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultItemConfigSelector = exports.termIdFromTermSelector = exports.defaultTermIdSelector = exports.availableTermsForMerchSelector = exports.itemConfigsWithMandatoryMerchSelector = exports.onboardingMerchItemConfigSelector = exports.getRecurringMerchItemConfigs = undefined;

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

var _Terms = require('self-service-api/constants/Terms');

var _RequiredOnboardingSelectors = require('pricing-pages-unified-ui/selectors/RequiredOnboardingSelectors');

var _ContactsSelectors = require('pricing-pages-unified-ui/selectors/ContactsSelectors');

var _itemConfigUtils = require('pricing-pages-unified-ui/utils/itemConfigUtils');

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: This should be moved to itemConfigUtils
var getRecurringMerchItemConfigs = exports.getRecurringMerchItemConfigs = function getRecurringMerchItemConfigs(merchId, additionalUnitsQuantity) {
  if (!_ImmutableMerchandiseIdMap2.default[merchId]) {
    return [];
  }
  var additionalUnitMerchId = _ImmutableMerchandiseIdMap2.default[merchId].additionalUnitMerchId;

  var additionalUnitMerchSameAsPrimaryMerch = additionalUnitMerchId === merchId;
  var hasAdditionalUnit = additionalUnitMerchId && additionalUnitsQuantity > 0;
  var shouldIncrementPrimaryMerchQuantity = additionalUnitMerchSameAsPrimaryMerch && hasAdditionalUnit;

  if (shouldIncrementPrimaryMerchQuantity) {
    var _primaryMerchItemConfig = (0, _itemConfigUtils.createItemConfigObject)({
      merchandiseId: merchId,
      quantity: additionalUnitsQuantity + 1
    });
    return [_primaryMerchItemConfig];
  }

  var primaryMerchItemConfig = (0, _itemConfigUtils.createItemConfigObject)({
    merchandiseId: merchId
  });
  var recurringMerchItemConfigs = [primaryMerchItemConfig];

  if (hasAdditionalUnit) {
    var additionalUnitMerchItemConfig = (0, _itemConfigUtils.createItemConfigObject)({
      merchandiseId: additionalUnitMerchId,
      quantity: additionalUnitsQuantity
    });
    recurringMerchItemConfigs.push(additionalUnitMerchItemConfig);
  }

  return recurringMerchItemConfigs;
};

var onboardingMerchItemConfigSelector = exports.onboardingMerchItemConfigSelector = function onboardingMerchItemConfigSelector(state, merchId) {
  var requiredOnboardingMerchId = (0, _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector)(state, merchId);

  if (requiredOnboardingMerchId) {
    var onboardingItemConfig = (0, _itemConfigUtils.createItemConfigObject)({
      merchandiseId: requiredOnboardingMerchId
    });
    return onboardingItemConfig;
  }
  return null;
};

// TODO Can probably delete this and use the util createItemConfigWithMandatoryMerch instead.
// Returns an array of itemConfigurations
// including any mandatory associated merch (i.e. additional contacts, seats, or onboarding)
// Optional param additionalUnitsQuantity defines amount of contacts or seats to be included
var itemConfigsWithMandatoryMerchSelector = exports.itemConfigsWithMandatoryMerchSelector = function itemConfigsWithMandatoryMerchSelector(state, merchId, additionalUnitQuantity) {
  var recurringMerchItemConfigs = getRecurringMerchItemConfigs(merchId, additionalUnitQuantity);
  var onboardingMerchItemConfig = onboardingMerchItemConfigSelector(state, merchId);

  if (onboardingMerchItemConfig) {
    return recurringMerchItemConfigs.concat(onboardingMerchItemConfig);
  }
  return recurringMerchItemConfigs;
};

var availableTermsForMerchSelector = exports.availableTermsForMerchSelector = function availableTermsForMerchSelector(state, merchId) {
  var eligiblePromotions = (0, _PromotionSelectors.allPromotionsSelector)(state);

  return (0, _pricingUtils.getEligibleTermIds)({
    eligiblePromotions: eligiblePromotions,
    merchandiseId: merchId
  });
};

var defaultTermIdSelector = exports.defaultTermIdSelector = function defaultTermIdSelector(state, merchId) {
  var eligibleTermIds = availableTermsForMerchSelector(state, merchId);

  if (!eligibleTermIds.monthly) {
    return eligibleTermIds.annual;
  }

  return eligibleTermIds.monthly;
};

var termIdFromTermSelector = exports.termIdFromTermSelector = function termIdFromTermSelector(state, term, merchId) {
  var eligibleTermIds = availableTermsForMerchSelector(state, merchId);

  if (term === _Terms.MONTHLY && eligibleTermIds.monthly) {
    return eligibleTermIds.monthly;
  }

  return eligibleTermIds.annual;
};

var defaultItemConfigSelector = exports.defaultItemConfigSelector = function defaultItemConfigSelector(state, merchId) {
  var isContactsBased = _MerchandiseIdLists.CONTACT_BASED_MERCHANDISE_IDS.includes(merchId);

  var additionalUnitQuantity = isContactsBased ? (0, _ContactsSelectors.minPurchasableContactsSelector)(state, merchId) : 0;

  var itemConfig = itemConfigsWithMandatoryMerchSelector(state, merchId, additionalUnitQuantity);

  return itemConfig;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ItemConfigsSelectors.js
// module id = 163
// module chunks = 3 4 5